import InterviewPracticeQuestionItem from './questionItem';
import React from 'react';
import { InterviewQuestionType } from '@components/pass/interview/start/context/interviewContext';

interface InterviewPracticeQuestionListProps {
  questionList: InterviewQuestionType[];
  className?: string;
}

const InterviewPracticeQuestionList = ({ questionList, className }: InterviewPracticeQuestionListProps) => {
  const renderQuestionEls = () => {
    return questionList.map((it) => <InterviewPracticeQuestionItem key={it.sn} data={it} />);
  };

  return <ul className={className}>{renderQuestionEls()}</ul>;
};

export default InterviewPracticeQuestionList;
